import { ClockIcon } from "@heroicons/react/24/outline";

import CallButton from "components/CallButton";
import type { ExpiredQuoteResponse } from "components/AtNeedQuote";

/**
 * Expired Quote View
 */
export default function ExpiredQuoteView(_props: {
  data: ExpiredQuoteResponse;
}) {
  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-oat">
        <ClockIcon className="h-8 w-8 text-soil" />
      </div>
      <h1 className="mb-4 font-serif text-3xl text-soil">
        This quote has expired
      </h1>
      <p className="mb-2 text-lg text-soil/70">
        Our quotes are valid for 7 days. Give us a call and our Care team can
        prepare a new one for you in just a few minutes.
      </p>
      <p className="mb-8 text-base text-soil/60">
        We're available 24/7 to help.
      </p>
      <CallButton variant="inline" />
    </div>
  );
}
